<template>
    <div>
        <b-dropdown ref="dropdown" size="sm" id="dropdown-notificaciones" dropleft no-caret no-flip class="notifications">
            <template #button-content>
                <i style="font-size: 20px;" class="fas fa-bell"></i>
                <div class="notifications-menu" v-if="notificaciones && notificaciones.length > 0">
                    <b-badge>{{ notificaciones.length }}</b-badge>
                </div>
            </template>
            <b-dropdown-header class="text-center border-bottom">Nuevas notificaciones: <span class="red">{{ notificaciones.length }}</span></b-dropdown-header>
            <div v-if="notificaciones && notificaciones.length > 0" style=" max-height: 330px; overflow-y: auto;">
                <div v-for="notificacion in notificaciones" :key="notificacion.id" class="d-flex align-items-center p-2">
                    <i class="fas fa-bell mr-2" style="cursor: pointer;" @click="marcarComoLeida(notificacion)"></i>
                    <div style="width: 300px;">
                        <b-dropdown-text v-html="notificacion.data.mensaje"/>
                        <span class="red" style="font-size: 13px;">{{ formaterFecha(notificacion.created_at) }}</span>
                    </div>
                </div>
            </div>
            <b-dropdown-text v-else class="p-2">No tienes notificaciones.</b-dropdown-text>
            <div v-if="notificaciones && notificaciones.length > 0" class="border-top pt-2 text-center">
                <span style="color: rgb(108, 117, 125)" role="button" @click="marcarComoLeidas()">MARCAR COMO LEIDAS</span>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
    import apiService from '@/services/notificaciones-boletines';

    export default {
        data() {
            return {
                notificaciones: []
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getNotificaciones();
        },
        mounted() {
            if (this.user && this.user.id) {
                this.$echo.channel('manager.user.' + this.user.id).on('new.notification', e => {
                    this.notificaciones.push(e);
                });
            }
        },
        methods: {
            async getNotificaciones(){
                let params = {
                    filters: {}
                }
                this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.get'), params).then(res => {
                    this.notificaciones = res.data.data;
                });

                if(this.teatro.marketing_api_token) {
                    try {
                        const notificaciones = await apiService.getNotificaciones();
                        notificaciones.data.forEach(notificacion => {
                            this.notificaciones.push({
                                id: notificacion.id,
                                data: {
                                    mensaje: notificacion.mensaje
                                },
                                created_at: notificacion.created_at,
                                tipo: 'comunicados'
                            });
                        });
                    } catch (error) {
                        this.$toast.error(error.response?.data?.message);
                    }
                }
            },
            async marcarComoLeida(notificacion) {
                if(notificacion.tipo == 'comunicados' && this.teatro.marketing_api_token){
                    try {
                        await apiService.marcarNotificacionLeida(notificacion.id);
                        this.getNotificaciones();
                    } catch (error) {
                        this.$toast.error(error.response?.data?.message);
                    }
                } else {
                    let params = {
                        filters: {},
                        notificacion_id: notificacion.id
                    }
                    this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.marcar-como-leida'), params).then(() => {
                        this.getNotificaciones();
                        this.$toast.success('Notificación leída correctamente')
                    }).catch(error => {
                        this.$toast.error(error.response.data.message);
                    });
                }
                
                if (this.notificaciones == []) {
                    this.$refs.dropdown.hide();    
                }
            },
            marcarComoLeidas(){
                if (this.teatro.marketing_api_token) {
                    this.marcarComoLeidaComunicado();
                }

                let params = {
                    filters: {}
                }
                this.$store.dispatch(this.config.getVuexAlias('back.notificaciones.marcar-como-leidas'), params).then(() => {
                    this.notificaciones = [];
                    this.$refs.dropdown.hide();
                    this.$toast.success('Notificaciónes leídas correctamente')
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            },
            async marcarComoLeidaComunicado() {
                try {
                    await apiService.marcarNotificacionLeidaMasiva();
                    this.$refs.dropdown.hide();
                } catch (error) {
                    this.$toast.error(error.response?.data?.message);
                }
            },
            formaterFecha(fecha) {
                if(!fecha){
                    return '';
                }
                const date = new Date(fecha);
                const dia = String(date.getDate()).padStart(2, '0');
                const mes = String(date.getMonth() + 1).padStart(2, '0');
                const anio = date.getFullYear();

                const horas = String(date.getHours()).padStart(2, '0');
                const minutos = String(date.getMinutes()).padStart(2, '0');

                return `${dia}-${mes}-${anio} ${horas}:${minutos}`;
            }
        }
    }
</script>

<style>
    .notifications-menu {
        font-size: 18px;
        position: absolute;
        bottom: 50%;
        right: .1%
    }

    .notifications .dropdown-menu {
        max-height: 80vh;
        overflow-y: auto;
    }

    #dropdown-notificaciones__BV_toggle_ {
        background-color: transparent !important;
        border: none !important;
        width: 50px;
    }
</style>